import { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(!!Cookies.get("jwtToken"));
    const [user, setUser] = useState(Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null);

    // Function to check auth status
    const checkAuthStatus = () => {
        const token = Cookies.get("jwtToken");
        const storedUser = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;

        console.log("Checking Auth Status:", { token, storedUser }); // ✅ Debugging

        setIsAuthenticated(!!token);
        setUser(storedUser);
    };

   useEffect(() => {
    console.log("AuthProvider Mounted!"); // ✅ Debugging to check if `useEffect` runs
    checkAuthStatus(); // Initial check

    // Listen for storage changes
    const handleStorageChange = () => {
        console.log("Storage changed, checking auth status...");
        checkAuthStatus();
    };
    window.addEventListener("storage", handleStorageChange);

    return () => window.removeEventListener("storage", handleStorageChange);
}, []); // ✅ Runs only once when the component mounts

    // Login function
    // const login = (jwtToken, refreshToken, userData) => {
    //     Cookies.set("jwtToken", jwtToken, { expires: 1, secure: true, sameSite: "Strict" });
    //     Cookies.set("refreshToken", refreshToken, { expires: 7, secure: true, sameSite: "Strict" });
    //     Cookies.set("user", JSON.stringify(userData), { expires: 1, secure: true, sameSite: "Strict" });
    //     const storedUser = Cookies.get("user") ? JSON.parse(Cookies.get("user")) : null;
    //     console.log("storedUser ",storedUser);

    //     setIsAuthenticated(true);
    //     setUser(userData);
    // };


    const login = (jwtToken, refreshToken, userData) => {
        Cookies.set("jwtToken", jwtToken, { expires: 1, secure: true, sameSite: "Strict" });
        Cookies.set("refreshToken", refreshToken, { expires: 7, secure: true, sameSite: "Strict" });
        Cookies.set("user", JSON.stringify(userData), { expires: 1, secure: true, sameSite: "Strict" });
        console.log("User logged in:", userData); // Debugging
        setIsAuthenticated(true);
        setUser(userData);
    };

    // Logout function
    const logout = () => {
        Cookies.remove("jwtToken");
        Cookies.remove("refreshToken");
        Cookies.remove("user");

        setIsAuthenticated(false);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, user,userId: user?.id || null, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
